import { castArray } from "./castArray.js";
const appendPredicates = (objWithPredicates = {}, predicates) => {
  return {
    ...objWithPredicates,
    predicates: [
      ...objWithPredicates.predicates || [],
      ...castArray(predicates)
    ]
  };
};
export {
  appendPredicates
};
//# sourceMappingURL=appendPredicates.js.map
